<div *ngIf="marketplaceItem$ | async as item">
  <!-- Image Mobile-->
  <ng-container *ifScreenSize="screenSize.Mobile">
    <div class="loyalty-details-image card border-0 overflow-hidden p-0">
      <img
        class="card-img"
        src="{{ item.ItemImageURL | contentImage: '7' : 'marketplace' }}"
        [alt]="item.DisplayName"
        draggable="false"
      />
      <fgbcl-social-share-modal
        shareType="rewards"
        [itemId]="itemId"
        urlPage="rewards/marketplace/details"
        [loyaltyCategoryType]="loyaltyCategoryType"
      ></fgbcl-social-share-modal>
    </div>
  </ng-container>
  <div class="container">
    <div class="d-block d-lg-flex pt-lg-3">
      <!-- Image -->
      <ng-container *ifScreenSize="screenSize.Desktop">
        <div class="loyalty-details-image card border-0 p-0">
          <img
            class="card-img"
            src="{{ item.ItemImageURL | contentImage: '7' : 'marketplace' }}"
            [alt]="item.DisplayName"
            draggable="false"
          />
          <fgbcl-social-share-modal
            shareType="rewards"
            [itemId]="itemId"
            urlPage="rewards/marketplace/details"
            [loyaltyCategoryType]="loyaltyCategoryType"
          ></fgbcl-social-share-modal>
        </div>
      </ng-container>
      <!-- Details -->
      <div class="loyalty-details w-100">
        <!--Sponsor-->
        <ng-container *ngIf="item?.Sponsor?.SponsorImage">
          <div class="rewards-details-sponsor ps-lg-3 pt-3 pt-lg-0">
            <span class="rewards-details-sponsor-text"> {{ item?.Sponsor?.SponsorText }} </span>
            <a [attr.href]="item?.Sponsor?.SponsorLink || null" [attr.target]="item?.Sponsor?.SponsorLink ? '_blank' : null">
              <img src="{{ item?.Sponsor?.SponsorImage | contentImage: '7' : 'marketplace' }}" />
            </a>
          </div>
        </ng-container>
        <ng-container *ngIf="stockAvailableState">
          <div class="rewards-item-panel-status mt-lg-0 mt-3 ms-lg-3 {{ textColor }}">
            <ng-container *ngIf="stockAvailableState == MARKETPLACE_STATE.REMAINING">
              <span class="item-count me-1">{{ item.AvailabilityCount }}</span>
            </ng-container>

            <span class="item-state">{{ stockAvailableState | translate }}</span>
          </div>
        </ng-container>
        <h2
          class="rewards-item-name ps-0 ps-lg-3 mt-lg-1 my-0 {{ stockAvailableState }}"
          id="header-name"
          [ngClass]="item?.Sponsor?.SponsorImage ? 'mt-0' : 'mt-3'"
        >
          {{ item.DisplayName }}
        </h2>
        <!-- Card Body -->
        <div class="card-body d-flex flex-column justify-content-between pe-lg-3 pe-0 ps-0 ps-lg-3 pb-4 pt-1">
          <!-- Item Details -->
          <!-- Points -->
          <ng-container *ngIf="!item.MerchantValue || item.MerchantValue === 0">
            <div class="marketplace-details-points" *ngIf="!item.EcashValue">
              <span *ngIf="item.PointValue > 0" class="rewards-item-details pt-1" id="points-value">{{
                item.PointValue | FortressCurrencyPipe: 'PTS'
              }}</span>
              <!--Display text if value is 0-->
              <span *ngIf="item.PointValue == 0" class="rewards-item-details pt-1" id="points-value">{{
                'fgbcl.marketplace.item.free' | translate
              }}</span>
            </div>
          </ng-container>
          <fgbcl-countdown [endDateTime]="item.ItemEndDate" [showTimer]="false" (complete)="marketplaceEnd()"></fgbcl-countdown>
          <!-- Merchant-->
          <ng-container *ngIf="item.MerchantValue > 0">
            <div class="marketplace-details-points">
              <span class="rewards-item-details pt-1" id="merchant-value">{{
                item.MerchantValue / 100 | FortressCurrencyPipe
              }}</span>
            </div>
          </ng-container>
          <!-- Ecash -->
          <div class="marketplace-ecash" *ngIf="item.EcashValue > 0">
            <span class="rewards-item-details pt-1" id="ecash-value">{{ item.EcashValue / 100 | FortressCurrencyPipe }}</span>
          </div>

          <ng-container *ifItemEnabled="item; else disabledTemplate">
            <!-- Attributes -->
            <fgbcl-marketplace-attributes
              *ngIf="originalStatus == 0"
              class="d-flex flex-column flex-lg-row w-100"
              [marketplaceItem]="item"
              (attributeMapping)="onAttributeValueChange(item, $event)"
            ></fgbcl-marketplace-attributes>
            <!--Custom Fields-->
            <fgbcl-marketplace-custom-fields
              *ngIf="item.CustomFields && item.CustomFields.length > 0 && item.Status === 0"
              [itemCustomFields]="item.CustomFields"
              [hasSumbittedForm]="hasSumbittedForm"
              (customFieldsChange)="setCustomFields($event)"
            >
            </fgbcl-marketplace-custom-fields>
            <!--Terms and Condtions Checkbox-->
            <div *ngIf="marketplaceItem.ShowTermsAndConditions && marketplaceItem.Status === 0">
              <div class="form-check">
                <input
                  [(ngModel)]="termsAccepted"
                  (ngModelChange)="marketplaceActionsComponent.updateTermsAndCondtions($event)"
                  class="form-check-input"
                  id="checkbox"
                  type="checkbox"
                />
                <label
                  [ngClass]="termsAccepted ? 'rewards-terms-checked' : 'rewards-terms-unchecked'"
                  class="rewards-terms-label ms-1 mt-1"
                  for="checkbox"
                >
                  {{ 'marketplace.terms.accept' | translate }}
                </label>
              </div>
            </div>
            <!-- Bottom Buttons -->
            <fgbcl-marketplace-actions
              *ngIf="item"
              [marketplaceItem]="item"
              [marketplaceItemType]="marketplaceItemType.type"
              [attributeMappingID]="attributeMappingID"
              [selectedAttributes]="selectedAttributes"
              [validCustomFields]="validCustomFields"
              [hasECash]="false"
              [theme]="theme"
              [actionLabels]="actionLabels"
              [availableStock]="availableStock"
              (purchaseLoading)="updateLoading($event)"
              (hasSumbittedForm)="submitForm()"
              [isCheckTC]="termsAccepted"
            >
            </fgbcl-marketplace-actions>
          </ng-container>
          <!-- Error -->
          <fgbcl-error></fgbcl-error>

          <!-- Disabled Item Display -->
          <ng-template #disabledTemplate let-status>
            <!-- Disabled Status -->
            <div class="status-container">
              <fgbcl-reward-status
                [status]="status.data"
                [startDate]="item.RequestTime"
                [comingSoonDate]="item.ItemStartDate"
                (itemStart)="status.refresh(true)"
              >
              </fgbcl-reward-status>
            </div>
          </ng-template>

          <!-- Description & Terms Nav -->
          <div class="rewards-details-desc-terms accordion accordion-flush" id="marketplaceDescTerms">
            <div class="accordion-item">
              <div id="marketplace-description">
                <button
                  class="accordion-button rewards-item-description-title"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#marketplaceDesc"
                  aria-expanded="true"
                >
                  {{ 'marketplace.item.description' | translate }}
                </button>
              </div>
              <div id="marketplaceDesc" class="accordion-collapse collapse show" data-bs-parent="#marketplaceDescTerms">
                <div class="rewards-item-description" [innerHtml]="item.DescriptionText | safeHtml"></div>
              </div>
            </div>
            <ng-container *ngIf="marketplaceItem.ShowTermsAndConditions">
              <div class="accordion-item">
                <div class="accordion-header" id="marketplace-terms">
                  <button
                    class="accordion-button collapsed rewards-item-terms"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#marketplaceTerms"
                    aria-expanded="false"
                  >
                    {{ 'marketplace.item.tcs' | translate }}
                  </button>
                </div>
                <div id="marketplaceTerms" class="accordion-collapse collapse" data-bs-parent="#marketplaceDescTerms">
                  <!--Text T&Cs-->
                  <ng-container *ngIf="marketplaceItem.TermsAndConditionsType === TermsAndCondtionsType.Text">
                    <div class="rewards-item-terms-text" [innerHtml]="item.TermsAndConditions | safeHtml"></div>
                  </ng-container>
                  <!--URL T&Cs-->
                  <ng-container *ngIf="marketplaceItem.TermsAndConditionsType === TermsAndCondtionsType.URL">
                    <a [href]="item.TermsAndConditions" target="_blank" class="rewards-item-terms-url" id="link-url">{{
                      item.TermsAndConditions
                    }}</a>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="loading">
  <div class="full-screen-splash">
    <fgbcl-loading></fgbcl-loading>
  </div>
</ng-container>
